export default [
  {
    icon: 'md-fibermanualrecord',
    value: 0,
    label: 'Bullet',
    md: ['.', '.'],
    highlight: 'pink lighten-5',
    color: 'blue-grey--text text--lighten-3',
    colors: ['blue-grey lighten-3', 'blue-grey lighten-4', 'blue-grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'info'
  },
  {
    icon: 'md-shorttext',
    value: 12,
    label: 'Note',
    md: ['/', '/'],
    highlight: 'pink lighten-5',
    color: 'blue-grey--text text--darken-1',
    colors: ['blue-grey darken-1', 'blue-grey lighten-4', 'blue-grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'info'
  },
  {
    icon: 'md-layers',
    value: 5,
    label: 'Project',
    highlight: 'pink lighten-5',
    color: 'grey--text text--darken-1',
    colors: ['blue-grey darken-1', 'blue-grey lighten-4', 'blue-grey darken-2'],
    md: ['{', '{'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'hide'
  },
  {
    icon: 'md-menubook', // list
    value: 19,
    label: 'Notebook',
    highlight: 'pink lighten-5',
    color: 'grey--text text--darken-1',
    colors: ['blue-grey darken-1', 'blue-grey lighten-4', 'blue-grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    md: ['{', '{'],
    type: 'group'
  },
  {
    icon: 'md-folder', // folder
    value: 7,
    label: 'Folder',
    md: [';', ';'],
    color: 'grey--text',
    highlight: 'pink lighten-5',
    colors: ['grey', 'grey lighten-4', 'grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'group'
  },
  // {
  //   icon: 'dashboard', // folder
  //   value: 21,
  //   label: 'Board',
  //   color: 'grey',
  //   type: 'group'
  // },
  {
    icon: 'md-listalt',
    value: 11,
    label: 'List',
    color: 'grey--text text--darken-1',
    highlight: 'pink lighten-5',
    colors: ['grey darken-1', 'grey lighten-4', 'grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'hide',
    md: [':', ':']
  },
  // {
  //   icon: 'fontdownload',
  //   value: 16,
  //   label: 'Header',
  //   color: 'transparent',
  //   type: 'group'
  // },
  {
    icon: 'md-emojiobjects',
    value: 3,
    label: 'Idea',
    md: ['@', '@'],
    highlight: 'pink lighten-5',
    color: 'light-blue--text text--accent-3',
    colors: ['light-blue accent-3', 'light-blue lighten-4', 'light-blue darken-1'],
    iconClasses: ['', '', 'light-blue lighten-4 rounded-circle'],
    type: 'action'
  },
  {
    icon: 'md-help',
    value: 1,
    label: 'Question',
    md: ['?', '?'],
    color: 'green--text',
    highlight: 'pink lighten-5',
    type: 'action'
  },
  {
    icon: 'md-warning',
    value: 2,
    label: 'Concern',
    md: ['!', '!'],
    highlight: 'pink lighten-5',
    color: 'yellow--text text--darken-4',
    colors: ['amber darken-3', 'orange lighten-4', 'amber darken-4'],
    iconClasses: ['', '', 'amber lighten-4 lighten-3 rounded-circle'],
    type: 'action'
  },
  // {
  //   icon: 'map',
  //   value: 20,
  //   label: 'Plan',
  //   style: 'transform: scaleX(1.5);',
  //   md: ['$', '$'],
  //   color: 'blue darken-1',
  //   type: 'action'
  // },
  {
    icon: 'md-assignmentturnedin',
    // icons: ['checkboxoutlineblank', 'checkbox', 'checkboxoutlineblank'],
    value: 6,
    label: 'Task',
    highlight: 'pink lighten-5',
    md: ['-', '-'],
    color: 'red--text text--lighten-1',
    colors: ['red lighten-2', 'grey lighten-1', 'red'],
    iconClasses: ['', '', 'red lighten-4 rounded-circle'],
    // shapeClasses: ['red lighten-3', '', 'red lighten-1'],
    // shapeStyles: [
    //   'position: absolute;top: 7px;   left: 9px;    right: 9px;    bottom: 7px;     border-radius: 1px;',
    //   '',
    //   'position: absolute;top: 7px;   left: 9px;    right: 9px;    bottom: 7px;     border-radius: 1px;'
    // ],
    type: 'action'
  },
  // {
  //   type: 'divider',
  //   label: 'Information'
  // },
  {
    icon: 'md-stickynote2-outlined',
    value: 8,
    label: 'Sheet',
    highlight: 'pink lighten-5',
    color: 'blue-grey--text',
    colors: ['blue-grey', 'blue-grey lighten-2', 'blue-grey darken-2'],
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'page',
    md: ['#', '#']
  },
  {
    icon: 'md-article',
    value: 9,
    label: 'Note Card',
    color: 'blue-grey--text text--lighten-1',
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'hide',
    md: ['$', '$']
  },
  {
    icon: 'md-flag',
    value: 4,
    label: 'Key Info',
    highlight: 'pink lighten-5',
    color: 'blue-grey--text text--darken-1',
    iconClasses: ['', '', 'red lighten-5 rounded-circle'],
    type: 'info',
    md: ['*', '*']
  },
  {
    icon: 'md-formatquote',
    value: 13,
    label: 'Quote',
    md: ['"', '"'],
    highlight: 'pink lighten-5',
    color: 'blue-grey--text text--darken-1',
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    type: 'info'
  },
  // {
  //   icon: 'locallibrary',
  //   value: 14,
  //   label: 'Wiki',
  //   color: 'grey darken-1',
  //   type: 'page'
  // },
  {
    icon: 'md-group',
    value: 15,
    label: 'Meeting',
    highlight: 'pink lighten-5',
    color: 'grey--text text--darken-1',
    iconClasses: ['', '', 'blue lighten-5 rounded-circle'],
    md: ['m', 'm'],
    type: 'hide'
  },
  {
    icon: 'md-label', // section
    value: 10,
    label: 'Section',
    highlight: 'pink lighten-5',
    color: 'grey--text text--darken-1',
    iconClasses: ['', '', 'blue-grey lighten-4 rounded-circle'],
    md: ['>', '>'],
    type: 'page'
  }
  // {
  //   icon: 'timer',
  //   value: 17,
  //   label: 'Log',
  //   color: 'grey darken-1',
  //   type: 'info'
  // }
];
